<template>
    <v-row justify="center">
        <v-dialog
                v-model="dialog"
                persistent
                max-width="400"
        >
            <v-card>
                <v-card-title class="headline">
                    {{ confirmMsg }}
                </v-card-title>
                <v-card-text text-center>{{confirmBody}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="green darken-1"
                            text
                            @click="hide(false)"
                            v-if="showCancelBtn"
                    >
                       Cancel
                    </v-btn>
                    <v-btn
                            color="red darken-1"
                            text
                            @click="hide(true)"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    export default {
        name: "Confirm",
        props: {
            dialog: {
                type: Boolean
            },
            showCancelBtn: {
                type: Boolean
            },
            confirmMsg: {
                type: String
            },
            confirmBody: {
                type: String
            }
        },
        methods: {
            hide(answer){
                this.$emit('hide-confirm', answer);
            }

        }
    }
</script>
